import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckIcon, Loader2Icon, MailIcon, PhoneIcon } from "lucide-react";
import { BracketButton } from "./BracketButton";
import { Overline } from "./Overline";
import { useContactForm } from "../hooks/useContactForm";
import { images, situations } from "../data/content";
export function ContactSection() {
  const {
    values,
    errors,
    status,
    update,
    submit,
    reset
  } = useContactForm();
  return <section id="contact" className="scroll-mt-20 bg-brand-soft py-24 md:py-36" data-id="element-71" data-mp="3d6i1r5xtojmj">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 md:px-10 lg:grid-cols-12 lg:gap-10" data-id="element-72" data-mp="3i6mjt0edpmev">
        <div className="lg:col-span-5" data-id="element-73" data-mp="347d5k69qh2dj">
          <Overline data-id="element-74" data-mp="388yczc3i0ogc">Contact</Overline>
          <h2 className="mt-6 text-[44px] font-semibold leading-[0.95] tracking-[-0.04em] md:text-[72px]" data-id="element-75" data-mp="387wz6zv3lnux">
            Parlons de <span className="font-serif font-normal italic text-brand-deep" data-id="element-76" data-mp="1sr6clqk0marm">votre projet.</span>
          </h2>
          <p className="mt-8 max-w-md text-[17px] leading-relaxed text-ink-muted" data-id="element-77" data-mp="1wrym8kwsuhof">
            Laissez-moi vos coordonnées : je vous rappelle sous 48 h pour un échange sans engagement.
          </p>
          <div className="mt-12 flex items-center gap-5 border-t border-ink/10 pt-8" data-id="element-78" data-mp="2p69ds8w8r2y">
            <img src={images.portraitRound} alt="" className="h-16 w-16 rounded-full object-cover" data-id="element-79" data-mp="go5x8xol11y2" />
            <div className="space-y-1.5 text-[15px]" data-id="element-80" data-mp="cjy50qix13v3">
              <p className="font-semibold" data-id="element-81" data-mp="qk8x1wvyoohu">Jérémy Couput</p>
              <a href="mailto:contact@jeremycouput.com" className="flex items-center gap-2 text-ink-muted hover:text-ink" data-id="element-82" data-mp="qio0y2u00xhv">
                <MailIcon className="h-4 w-4" data-id="element-83" data-mp="10ak9k7tpo60c" /> contact@jeremycouput.com
              </a>
              <a href="tel:+33600000000" className="flex items-center gap-2 text-ink-muted hover:text-ink" data-id="element-84" data-mp="vbr14tta7571">
                <PhoneIcon className="h-4 w-4" data-id="element-85" data-mp="19b8or5uuccet" /> 06 00 00 00 00
              </a>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 md:p-12 lg:col-span-7" data-id="element-86" data-mp="14dgnvmc7xfyh">
          <AnimatePresence mode="wait" initial={false} data-id="element-87" data-mp="1z9dgnnadug1">
            {status === "success" ? <motion.div key="success" initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.96
          }} transition={{
            duration: 0.25,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex min-h-[460px] flex-col items-start justify-center" role="status" data-id="element-88" data-mp="6y3x1rt2vn17">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand text-white" data-id="element-89" data-mp="po2bcpngycda">
                  <CheckIcon className="h-7 w-7" data-id="element-90" data-mp="unevv3qvb7cp" />
                </span>
                <h3 className="mt-6 text-[36px] font-semibold tracking-[-0.03em]" data-id="element-91" data-mp="yp07ymvkvhlu">Merci {values.name.split(" ")[0]} !</h3>
                <p className="mt-3 max-w-md text-[17px] leading-relaxed text-ink-muted" data-id="element-92" data-mp="2wftfc7928jv8">
                  Votre demande est bien reçue. Je vous recontacte très vite au {values.phone}.
                </p>
                <button onClick={reset} className="mt-8 text-[14px] font-semibold text-brand-deep underline underline-offset-4" data-id="element-93" data-mp="2sy5oofzrrtoa">
                  Envoyer une autre demande
                </button>
              </motion.div> : <motion.form key="form" onSubmit={submit} noValidate initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.15
          }} className="grid gap-x-6 gap-y-7 md:grid-cols-2" data-id="element-94" data-mp="2j583g23e7qlz">
                <Field id="name" label="Nom complet" error={errors.name} data-id="element-95" data-mp="32u8m58jof44w">
                  <input id="name" autoComplete="name" value={values.name} onChange={e => update("name", e.target.value)} className={inputCls(errors.name)} data-id="element-96" data-mp="2xwqfxpx1n30l" />
                </Field>
                <Field id="email" label="E-mail" error={errors.email} data-id="element-97" data-mp="1mh1u51vj0a1d">
                  <input id="email" type="email" autoComplete="email" value={values.email} onChange={e => update("email", e.target.value)} className={inputCls(errors.email)} data-id="element-98" data-mp="1mj4q02jd0xe0" />
                </Field>
                <Field id="phone" label="Téléphone" error={errors.phone} data-id="element-99" data-mp="3f6j9pznupi65">
                  <input id="phone" type="tel" autoComplete="tel" value={values.phone} onChange={e => update("phone", e.target.value)} className={inputCls(errors.phone)} data-id="element-100" data-mp="31emjk15qtice" />
                </Field>
                <Field id="city" label="Ville ou secteur" error={errors.city} data-id="element-101" data-mp="3t5itou0f58vz">
                  <input id="city" value={values.city} onChange={e => update("city", e.target.value)} className={inputCls(errors.city)} data-id="element-102" data-mp="1y6bcbnsupeh" />
                </Field>
                <Field id="situation" label="Votre situation" error={errors.situation} full data-id="element-103" data-mp="3p2m94xrbj2pe">
                  <select id="situation" value={values.situation} onChange={e => update("situation", e.target.value)} className={inputCls(errors.situation)} data-id="element-104" data-mp="3p4gs46j14kqu">
                    <option value="" data-id="element-105" data-mp="2dp1zfexusf1j">Sélectionner…</option>
                    {situations.map(s => <option key={s} value={s} data-id="element-106" data-mp="254vmouvclzik">
                        {s}
                      </option>)}
                  </select>
                </Field>
                <Field id="message" label="Message (facultatif)" full data-id="element-107" data-mp="2f3l6it6t1u1g">
                  <textarea id="message" rows={3} value={values.message} onChange={e => update("message", e.target.value)} className={`${inputCls()} resize-none`} data-id="element-108" data-mp="2a51imn8ni86g" />
                </Field>

                <div className="md:col-span-2" data-id="element-109" data-mp="1hh5nvo2n6qcb">
                  <label className="flex items-start gap-3 text-[14px] leading-relaxed text-ink-muted" data-id="element-110" data-mp="1higr9ms6dw2w">
                    <input type="checkbox" checked={values.consent} onChange={e => update("consent", e.target.checked)} className="mt-1 h-4 w-4 accent-[#F26522]" aria-invalid={!!errors.consent} data-id="element-111" data-mp="1w7d0hn5yxf53" />
                    J'accepte d'être recontacté au sujet de l'opportunité SAFTI et que mes données soient utilisées à cette fin.
                  </label>
                  {errors.consent && <p className="mt-2 text-[13px] text-red-700" data-id="element-112" data-mp="33pw1zxfsmibs">{errors.consent}</p>}
                </div>

                <div className="flex flex-wrap items-center gap-4 md:col-span-2" data-id="element-113" data-mp="38j8n3xl9k6zs">
                  <BracketButton type="submit" disabled={status === "submitting"} data-id="element-114" data-mp="3cjiu9dksl3g8">
                    {status === "submitting" ? <>
                        <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-115" data-mp="2kscrepdosrn9" /> Envoi…
                      </> : "Envoyer ma demande"}
                  </BracketButton>
                  {status === "error" && <p className="text-[14px] text-red-700" role="alert" data-id="element-116" data-mp="2tr6ki5rt6zw2">
                      Merci de corriger les champs indiqués.
                    </p>}
                </div>
              </motion.form>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}
function inputCls(error?: string) {
  return `w-full border-0 border-b bg-transparent px-0 py-2.5 text-[16px] text-ink outline-none transition-colors duration-150 focus:border-brand focus:ring-0 ${error ? "border-red-600" : "border-ink/20"}`;
}
function Field({
  id,
  label,
  error,
  full,
  children
}: {
  id: string;
  label: string;
  error?: string;
  full?: boolean;
  children: React.ReactNode;
}) {
  return <div className={full ? "md:col-span-2" : ""} data-id="element-117" data-mp="3rnby4v0vpxo7">
      <label htmlFor={id} className="text-[13px] font-medium uppercase tracking-[0.12em] text-ink-muted" data-id="element-118" data-mp="3rlr02vfcvwll">
        {label}
      </label>
      {children}
      {error && <p className="mt-1.5 text-[13px] text-red-700" data-id="element-119" data-mp="3in5mzfsnl9s7">{error}</p>}
    </div>;
}